import React from 'react';
import styled from 'styled-components';
import { darken } from 'polished';

import theme from '@styles/theme';

import { FlexBox, Description } from '@components/styled/StyledComponents';

type DetailProps = {
    title: string;
    value?: string;
    description?: string;
    articleTitle?: string;
    articleTime?: string;
    articleImage?: string;
    articleContents?: string | TrustedHTML;
    buttonTitle?: string;
    onButtonClick?: () => void;
    margin?: string;
};

type DetailHistoryProps = {
    histories: string[] | [];
};

export const DetailSection = ({ children }: { children: React.ReactNode }) => {
    return <Wrapper>{children}</Wrapper>;
};

export const DetailDataRow = ({
    title,
    value,
    description = '',
    buttonTitle = '',
    onButtonClick = () => null,
    margin
}: DetailProps) => {
    return (
        <DetailInfoRow $margin={margin}>
            <InfoTitle>{title}</InfoTitle>
            <FlexBox $flexDirection="column" $alignItems="flex-start">
                <FlexBox $justifyContent="space-between">
                    <InfoValue>{value}</InfoValue>
                    {buttonTitle && (
                        <Button onClick={onButtonClick}>{buttonTitle}</Button>
                    )}
                </FlexBox>
                {description && <Description>{description}</Description>}
            </FlexBox>
        </DetailInfoRow>
    );
};

export const DetailHistory = ({ histories }: DetailHistoryProps) => {
    if (histories.length === 0) {
        return <EmptyBox>히스토리가 없습니다.</EmptyBox>;
    }

    return (
        <>
            {histories.map((history, index) => {
                if (!history) return;

                const title = history?.split('&#58;')?.[0]?.trim();
                const value = history?.split('&#58;')?.[1]?.trim();

                return (
                    <DetailDataRow
                        key={`${index}-history-list`}
                        title={title}
                        value={value}
                        margin="0 0 20px"
                    />
                );
            })}
        </>
    );
};

const Wrapper = styled.section`
    padding: 32px 0;
    width: 100%;
    border-top: ${theme.colors.ultraLightGrayBorder} 1px solid;
`;

export const DetailInfoRow = styled.div<{ $margin?: string }>`
    display: flex;
    align-items: center;
    margin: ${({ $margin }) => ($margin ? $margin : 0)};
    width: 100%;
`;

export const InfoTitle = styled.span`
    padding-right: 20px;
    width: 162px;
`;

const InfoValue = styled.div`
    max-width: 650px;
    white-space: pre-line;
    line-height: 1.3;
`;

const Button = styled.button`
    min-width: 36px;
    font-size: 14px;
    color: ${theme.colors.deepGrayFontColor};
    transition: all.25s;
    &:hover {
        color: ${darken(0.35, theme.colors.deepGrayFontColor)};
    }
`;
const EmptyBox = styled.div`
    height: 100px;
    color: ${theme.colors.deepGrayFontColor};
    display: flex;
    align-items: center;
    justify-content: center;
`;
